import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
//redux
import { getChatsAtendimento, getChatInfoByChatId } from 'src/redux/slices/chat';
import { useDispatch } from 'src/redux/store';
//hooks
import useAuth from 'src/hooks/useAuth';
//components
import { RowInput } from 'src/components/forms/RowInput';
import Scrollbar from 'src/components/Scrollbar';
//sections
import ChatInfoContatoForm from './ChatInfoContatoForm';
import ModalNovoContato from './Modals/ModalNovoContato';
import ChatAIAnalysis from './ChatAIAnalysis';
// ui
import { Button } from 'src/@/components/ui/button';
import { Input } from 'src/@/components/ui/input';
import { Separator } from 'src/@/components/ui/separator';
import TagsComponent from 'src/components/tags/TagsComponent';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/@/components/ui/select';
//actions
import v2_actionEditarChat from 'src/actions/v2/chats/v2_actionEditarChat';
import getActionListaUsuariosByClienteId from 'src/actions/usuarios/getActionListaUsuariosByClienteId';
//utils
import { verifyFeatures } from 'src/utils/functions';

ChatInfoContato.propTypes = {
    isCollapse: PropTypes.bool,
    onCollapse: PropTypes.func
};

export default function ChatInfoContato({ cliente, chat, isCollapse, listaTags, onCollapse, messagesWpp, ...other }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar()
    const { listaRespostas } = useSelector((state) => state.chat);
    const [stateModalNovoContato, setStateModalNovoContato] = useState(false);
    const [nome, setNome] = useState(null);
    const [selectedOwner, setSelectedOwner] = useState(null);
    const [listaUsuarios, setListaUsuarios] = useState([]);
    const { user } = useAuth();
    //tags
    const [tagsChamado, setTagsChamados] = useState(chat.tags_ids);
    const [isChanges, setIsChanges] = useState(false);



    const buscarUsuarios = async () => {
        try {
            const response = await getActionListaUsuariosByClienteId(user.clienteId);
            setListaUsuarios(response.data.usuarios);
        } catch (error) {
            console.log('error', error);
        }
    };

    useEffect(() => {
        if (chat) {
            setNome(chat.nomeCliente ? chat.nomeCliente : "");
            setSelectedOwner(chat.wallet_user_id || null);
        }
        setTagsChamados(chat.tags_ids);
        buscarUsuarios();
    }, [chat]);

    useEffect(() => {
        return () => {
            setNome(null);
            setSelectedOwner(null);
        }
    }, [chat]);

    const handleEditarContato = async (scope, refreshLista) => {
        try {
            let data = {
                scope: scope
            }
            await v2_actionEditarChat(chat._id, data)
            setIsChanges(false);
            dispatch(getChatInfoByChatId(chat._id, chat.funil_id, user.id, false));
            enqueueSnackbar(t('chat.info.contact.updateSuccess'), { variant: 'success', autoHideDuration: 3000, anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            if (refreshLista) {
                dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, true));
            }
        } catch (error) {
            console.log('error', error)
            enqueueSnackbar(t('chat.info.contact.updateError'), { variant: 'error', autoHideDuration: 3000, anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        }
    }

    if (chat === undefined) {
        return null;
    }

    return (
        <Scrollbar className="h-auto max-h-[50vh]">
            <div className="p-1" {...other}>
                {chat && (
                    <>
                        <div className="space-y-4">
                            <div className="space-y-4">
                                <RowInput
                                    label={t('chat.info.contact.chatName')}
                                    input={<Input
                                        name="Nome"
                                        onChange={e => {
                                            setNome(e.target.value)
                                            setIsChanges(true)
                                        }}
                                        value={nome}
                                    />}
                                />


                                {verifyFeatures(cliente?.features || [], 'chats.wallet') && (
                                    <RowInput
                                        label={t('chat.info.contact.wallet')}
                                        input={<Select
                                            value={selectedOwner}
                                            onValueChange={(value) => {
                                                setSelectedOwner(value);
                                                setIsChanges(true);
                                            }}
                                            disabled={!isChanges && selectedOwner && !(user.level === 'root' || selectedOwner === user.id)}
                                        >
                                            <SelectTrigger>
                                                <SelectValue placeholder={t('chat.info.contact.selectOwner')} />
                                            </SelectTrigger>
                                            <SelectContent>
                                                {listaUsuarios.map((usuario) => (
                                                    <SelectItem key={usuario._id} value={usuario._id}>
                                                        {usuario.nomeFantasia}
                                                    </SelectItem>
                                                ))}
                                            </SelectContent>
                                        </Select>}
                                    />
                                )}
                            </div>

                            {chat?.canal === "instagram" && (
                                <div className="space-y-4">
                                    <div className="w-3/4">
                                        <RowInput
                                            label={t('chat.info.contact.instagramUser')}
                                            input={<Input
                                                name="Usuário Instagram"
                                                disabled
                                                value={`@${chat?.instagramUser?.profile?.username}`}
                                            />}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>

                        {isChanges && (
                            <div className="flex gap-2 mt-3">
                                <Button
                                    className="h-7 text-xs bg-violet-400"
                                    onClick={() => {
                                        let scope = {
                                            nomeCliente: nome,
                                            wallet_user_id: selectedOwner
                                        }
                                        handleEditarContato(scope, true)
                                    }}
                                >
                                    {t('common.buttons.saveChanges')}
                                </Button>
                            </div>
                        )}


                    </>
                )}
            </div>
        </Scrollbar>
    );
}
